import React, { useEffect, useState } from "react";
import {api} from "../utils/gashtaltAPI";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../components/Loader";
import Navbar from "../components/Navbar";
import { toast } from "react-toastify";

function Video() {
  const { examId } = useParams();
  const [videos, setVideos] = useState([]);
  const [loading,setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get("/api/exam/videos/" + examId);
        setVideos(response.data.data);
      } catch (error) {
        toast.error(error.response.data.message, {
          position: "bottom-right",
        });

        navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) return <Loader />
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div className="px-5 py-2 flex-fill d-flex flex-column  ">
        <a
          className={"btn btn-outline-blue my-3"}
          onClick={() => {
            navigate(-1);
          }}
        >
          بازگشت
        </a>
        {videos.length === 0 && (
          <h1 className={"text-center flex-fill align-items-center py-5"}>
            ویدیویی برای این آزمون وجود ندارد
          </h1>
        )}
        <div className={"row justify-content-around"}>
          {videos.map((video, index) => (
            <div dangerouslySetInnerHTML={{ __html: video.snippet }}></div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Video;
